<template>
  <div>
    <header-component />
    <div class="w-100 d-inline-block padding-top-4 padding-bottom-4">
      <div class="container autoContent text-center">
        <h1 class="half-black fw-bold filson-black-family text-full-32 margin-bottom-2">
          Page not found
        </h1>
        <p class="text-black text-size-15 inter-regular-family margin-bottom-3 text-full-14">
          The page you are looking for does not exist or has moved.
        </p>
        <div class="d-inline-flex flex-wrap justify-content-center gap-2">
          <router-link
            class="text-white text-size-14 d-inline-block book-online-btn border-green bg-green inter-bold-family text-full-11"
            to="/services/"
          >
            View Services
          </router-link>
          <router-link
            class="text-white text-size-14 d-inline-block book-online-btn border-green bg-green inter-bold-family text-full-11"
            to="/booking/"
          >
            Book Online
          </router-link>
          <a
            class="text-white text-size-14 d-inline-block bg-call inter-bold-family whats-btn text-uppercase text-full-11"
            :href="whatsappUrl"
            target="_blank"
            rel="noopener noreferrer"
            @click="trackWhatsApp"
          >
            WhatsApp
          </a>
        </div>
      </div>
    </div>
    <footer-component />
  </div>
</template>

<script>
import headerComponent from './header/headerComponent.vue';
import footerComponent from './footer/footerComponent.vue';
import { trackEvent, WHATSAPP_URL } from '@/utils/seo';

export default {
  name: 'NotFound',
  components: {
    headerComponent,
    footerComponent,
  },
  data() {
    return {
      whatsappUrl: WHATSAPP_URL,
    };
  },
  methods: {
    trackWhatsApp() {
      trackEvent('whatsapp_click', { source: 'not_found' });
    },
  },
};
</script>
